<template>
  <section class="py-4">
    <hr class="mx-auto" />
  </section>
</template>
